import { OptionCode } from '../../enums';
import { DeviceBroadcastNetwork, Origin } from '../../enums/Devices';
import mockedPaginatedResponse from './mockedPaginatedResponse';
import mockedRequester from './mockedRequester';
export const mockedStation = {
    kind: 'station',
    id: 17892,
    deviceId: 3456,
    name: "Noirmoutier-en-l'Île, Vendée",
    isDynamicName: true,
    isFavorite: false,
    createdAt: '1673009325',
    brand: 0,
    serial: '20C258',
    model: 'P+',
    availableMeasures: ['T', 'U', 'RR'],
    organizationId: 137,
    origin: Origin.fromOwnOrganization,
    networkId: null,
    timezone: 'Europe/Paris',
    lastMeasuredAt: '1681463834',
    lastLocatedAt: '1681464000',
    endUserName: ['P+', '20C258'],
    plotIds: [52423, 52555, 52588, 52407],
    location: {
        type: 'Point',
        coordinates: [-2.28703, 47.01407]
    },
    reverseGeocoding: "Noirmoutier-en-l'Île, Vendée",
    currentEvents: [],
    messageQuality: [100, 100, 100, 100, 100, 98, 100],
    currentMessageQuality: 100,
    activeOptions: [OptionCode.weephyt, OptionCode.cumulativeSum],
    broadcastNetwork: DeviceBroadcastNetwork.LoRa,
    rotronicProbeChange: '1600000000'
};
const mock = {
    get: mockedRequester(mockedStation, 'stations.get'),
    getMany: mockedRequester(mockedPaginatedResponse([mockedStation]), 'stations.getMany'),
    getPage: mockedRequester(mockedPaginatedResponse([mockedStation]), 'stations.getMany'),
    getAll: mockedRequester([mockedStation], 'stations.getMany'),
    create: mockedRequester(mockedStation, 'stations.create'),
    changeFavorite: mockedRequester(mockedStation, 'stations.changeFavorite'),
    delete: mockedRequester(undefined, 'stations.delete'),
    update: mockedRequester(mockedStation, 'stations.update')
};
export default mock;
